import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, InputAdornment } from '@mui/material';
import { AttachMoney } from '@mui/icons-material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotification } from '../../../context/NotificationContext';
import { addProductFromMasterCatalog } from '../services/masterProductsApi';

export default function ProductQuickAdd({ open, onClose, masterProduct, retailerId }) {
  const queryClient = useQueryClient();
  const [customPrice, setCustomPrice] = useState('');
  const [customName, setCustomName] = useState(masterProduct?.name || '');
  const notification = useNotification();

  const addMutation = useMutation({
    mutationFn: () => addProductFromMasterCatalog(retailerId, masterProduct.id, {
      price: parseFloat(customPrice) || 0,
      custom_name: customName !== masterProduct.name ? customName : null
    }),
    onSuccess: () => {
      notification.success('Product added to inventory!');
      queryClient.invalidateQueries(['products']);
      onClose();
    },
    onError: (error) => {
      notification.error('Failed to add product');
      console.error('Add product error:', error);
    }
  });

  const handleAdd = () => {
    if (!customPrice || parseFloat(customPrice) <= 0) {
      notification.error('Please enter a valid price');
      return;
    }
    addMutation.mutate();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add to Inventory</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TextField
            label="Product Name"
            value={customName}
            onChange={(e) => setCustomName(e.target.value)}
            fullWidth
            helperText="You can customize the product name for your store"
          />

          <TextField
            label="Price"
            type="number"
            value={customPrice}
            onChange={(e) => setCustomPrice(e.target.value)}
            fullWidth
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            }}
            helperText="Set your selling price"
          />

          {masterProduct?.package_size && (
            <TextField
              label="Package Size"
              value={masterProduct.package_size}
              fullWidth
              disabled
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleAdd}
          disabled={addMutation.isPending || !customPrice}
        >
          Add to Inventory
        </Button>
      </DialogActions>
    </Dialog>
  );
}
